export default {
  "Link": "Link",
  "Nagłówek": "Header",
  "Separator": "Separator",
  "Kolumna": "Column",
  "Podmenu": "Submenu",
  "Główny wpis": "Root",
  "Baner / zdjęcie": "Image banner",
  "Slider": "Slider",
  "Slider - element": "Slider - element",
  "Grid": "Grid",
  "Grid - element": "Grid - element",
  "Aby zobaczyć aktualne zdjęcie, prosimy o odświeżenie strony": "To show actual image, please refresh the page",
  "Zdjęcie menu zostało poprawnie zapisane.": "Menu image has been saved successfully.",
  "Menu zostało poprawnie zapisane.": "Menu has been saved successfully.",
  "Poprawnie usunięto ten wpis menu.": "Successfully deleted given menu entry.",
  "Czy jesteś pewien/na, że chcesz zmienić rodzica wpisu '{{prevNodeName}}' na '{{nextNodeName}}'": "Are you sure you want to change parent of given menu entry from '{{prevNodeName}}' to '{{nextNodeName}}?",
  "Poprawnie zmieniono kolejność elementów!": "Successfully saved elements ordering!",
  "Poprawnie zmieniono rodzica wybranego wpisu w menu!": "Successfully changed parent of given menu entry!",
  "Aby podejrzeć jak będzie wyglądać menu w praktyce, wejdź na stronę główną sklepu kobiet/męzczyzn/dzieci i do linku dodaj parametr": "To preview menu without cache, go to store's main page and add parameter",
  "Gdy zdeaktywujesz ten wpis menu, wszystkie jego dzieci również zostaną zdezaktywowane.": "When you deactivate this menu entry, all its children will also be deactivated.",
  "Wgrywanie zdjęcia": "Image uploading",
  'Uwaga': "Caution advised",
  "Wybór danego zdjęcia spowoduje natychmiastowe jego wysłanie na nasz serwer! Prosimy upewnić się, czy wrzucany plik na pewno jest prawidłowy.": "Choosing image will immediately upload it into server. Be sure that you're choosing proper image",
  "Zdjęcie baneru": "Banner image",
  "Wygląd na stronie": "Preview",
  "Pogrubienie": "Bold",
  "Kolor": "Color",
  "Podświetlenie": "Highlight",
  "Czerwony": "Red",
  "Pomarańczowy": "Orange",
  "Prostokąt": "Rectangle",
  "Okrąg": "Circle",
  "Mały": "Small",
  "Średni": "Medium",
  "Duży": "Big",
  "B. duży": "V. big",
  "Mała ikonka": "Small icon",
  "Brak małej ikonki": "No small icon",
  "Hot": "Hot",
  "Ikona": "Icon",
  "Wgrywanie zdjęcia ikony": "Icon image uploading",
  "Rozmiar ikony": "Icon's size",
  "Typ ikony": "Icon's type",
  "Szczegóły ikony": "Icon's details",
  "Typ bloku": "Block's type",
  "Wybierz rozmiar ikonki": "Choose icon's size",
  "Wgranie zdjęcia będzie możliwe po dodaniu wpisu menu.": "Image uploading is available after creation of menu entry.",
  "Powyżej": "Above",
  "Poniżej": "Below",
  "Na lewo": "To the left",
  "Na prawo": "To the right"
};



// WEBPACK FOOTER //
// ./locales/en_US/menus.js